/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'circle-add': {
    width: 40,
    height: 40,
    viewBox: '0 0 40 40',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M20 6C12.268 6 6 12.268 6 20s6.268 14 14 14 14-6.268 14-14S27.732 6 20 6zM4 20c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16S4 28.837 4 20z" _fill="#1F222C"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M26.656 20a1 1 0 01-1 1H14.343a1 1 0 110-2h11.313a1 1 0 011 1z" _fill="#1F222C"/><path pid="2" fill-rule="evenodd" clip-rule="evenodd" d="M20 13.343a1 1 0 011 1v11.314a1 1 0 11-2 0V14.343a1 1 0 011-1z" _fill="#1F222C"/>'
  }
})
